module.exports = __webpack_public_path__ + "img/Conmebol_BRAZIL_001.f2471d26.png";